import { render, staticRenderFns } from "./DateDurationExpressionBehaviorEditor.vue?vue&type=template&id=5ed771f5&scoped=true&"
import script from "./DateDurationExpressionBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./DateDurationExpressionBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DateDurationExpressionBehaviorEditor.vue?vue&type=style&index=0&id=5ed771f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed771f5",
  null
  
)

export default component.exports